import { extractIframeSource } from './iframe'

export function extractGoogleMapsEmbedUrl(value: string): string {
  return extractIframeSource(value)
}
